import React from "react"

export const NotFoundPage: React.FC = () => {
	
	
	return (
		<div>
            <div className="notFound-middle-box text-center animated fadeInDown">
                <h1>404</h1>
                <h3 className="font-bold">Página Não Encontrada</h3>

                <div className="error-desc">
                    Desculpe mas a página que você está procurando não foi encontrada. Confira se há algum erro na URL ou tente acessar alguma outra página.
                </div>
            </div>
        </div>    
	)
} 